import React from 'react'
import {
  Container,
  TextBody,
  TextCaption,
  FieldDate,
  RadioGroup,
  ListContainer
} from '@pmi/pmi-iqos-ds-react'
import { DeliveryDateMode, htmlTranslation } from '@pmi/pmi-iqos-shared-react'

const CheckoutDelivery = ({
  translations,
  dateMode,
  deliveryOptions,
  handleChangeMode,
  preorder,
  currentDelivery,
  currentDeliveryTimeSlot,
  handleChangeDate,
  handleChangeHour,
  loading
}) => {
  const isValidDate = d => {
    return d instanceof Date && !isNaN(d)
  }

  const availableDates = (deliveryOptions || [])
    .map(deliveryOption =>
      deliveryOption.day && isValidDate(new Date(deliveryOption.day.date))
        ? new Date(deliveryOption.day.date)
        : null
    )
    .filter(Boolean)

  const currentDate = currentDelivery
    ? currentDelivery.day
      ? new Date(currentDelivery.day.date)
      : null
    : null

  const dateModes =
    preorder || !deliveryOptions || deliveryOptions.length <= 0
      ? [
          {
            value: DeliveryDateMode.NO_DATE,
            content: (
              <Container
                fullHeight
                display={Container.displays.flex}
                justifyContent={Container.justifyContentValues.between}
                alignItems={Container.alignItemsValues.center}>
                <TextCaption size={TextBody.sizes.s}>
                  {preorder
                    ? translations.tk_checkoutPreOrder
                    : translations.tk_checkoutNoDateAvailable}
                </TextCaption>
              </Container>
            )
          }
        ]
      : [
          {
            value: DeliveryDateMode.NO_DATE,
            content: (
              <Container
                fullHeight
                display={Container.displays.flex}
                justifyContent={Container.justifyContentValues.between}
                alignItems={Container.alignItemsValues.center}>
                <TextCaption size={TextBody.sizes.s}>
                  {translations.tk_checkoutNoDateMode}
                </TextCaption>
              </Container>
            )
          },
          {
            value: DeliveryDateMode.DATE_SELECTION,
            content: (
              <Container
                fullHeight
                display={Container.displays.flex}
                justifyContent={Container.justifyContentValues.between}
                alignItems={Container.alignItemsValues.center}>
                <TextCaption size={TextBody.sizes.s}>
                  {availableDates.length > 0
                    ? translations.tk_checkoutDateMode
                    : translations.tk_checkoutTimeSlots}
                </TextCaption>
              </Container>
            )
          }
        ]

  const timeSlots =
    (currentDelivery &&
      currentDelivery.timeSlots.map(el => ({
        value: el.hour,
        label: el.label
      }))) ||
    []

  return (
    <Container pt="4" pb="8" px={['0', '8']}>
      <Container px={['8', '0']}>
        <RadioGroup
          alternative
          name="deliveryMode"
          label=""
          style={[RadioGroup.styles.default, RadioGroup.styles.square]}
          columns={[1, 2]}
          items={dateModes}
          getItemValue={(item, index) => dateModes[index].value}
          getItemContent={(item, index) => dateModes[index].content}
          isItemSelected={(item, index) => dateModes[index].value === dateMode}
          onChangeHandler={handleChangeMode}
          data-testing="Checkout_RadioGroup_DeliveryOptions"
        />
      </Container>
      {dateMode === DeliveryDateMode.DATE_SELECTION && (
        <Container pt="8">
          {availableDates.length > 0 && (
            <ListContainer columns={[1, 1, 2]} xBetween="8" overflow="visible">
              <Container fullWidth pb="6">
                <Container pb="3">
                  <TextBody
                    {...htmlTranslation(translations, 'tk_checkoutDate')}
                  />
                </Container>
                <FieldDate
                  value={currentDate}
                  pickerPosition={FieldDate.pickerPositions.top}
                  showMonthDropdown={false}
                  showYearDropdown={false}
                  name="deliveryDate"
                  label=""
                  onChangeHandler={handleChangeDate}
                  disabled={loading}
                  includeDates={availableDates}
                  highlightDates={availableDates}
                  data-testing="Checkout_FieldDate_DeliveryOptionsDate"
                />
              </Container>
            </ListContainer>
          )}
          <Container>
            <RadioGroup
              alternative
              name="deliveryHour"
              spacing={RadioGroup.spacingValues.small}
              label={translations.tk_checkoutTimeSlots}
              style={RadioGroup.styles.square}
              columns={0}
              items={timeSlots}
              getItemValue={(item, index) => timeSlots[index].value}
              getItemLabel={(item, index) => timeSlots[index].label}
              isItemSelected={(item, index) =>
                currentDeliveryTimeSlot &&
                currentDeliveryTimeSlot.hour &&
                timeSlots[index].value === currentDeliveryTimeSlot.hour
              }
              onChangeHandler={handleChangeHour}
              data-testing="Checkout_RadioGroup_DeliveryOptionsHour"
            />
          </Container>
        </Container>
      )}
    </Container>
  )
}

export default CheckoutDelivery
